import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.qadataset.reviewlog');
import { Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare const wiz: any;

@Component({
    selector: 'wiz-portal-qadataset-reviewlog',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.qadataset.reviewlog/view.scss */
/* src/app/portal.qadataset.reviewlog/view.scss: no such file or directory */`],
})
export class PortalQadatasetReviewlogComponent implements OnInit {
    @Input() id: string;

    public loading: boolean = false;
    public error: string | null = null;
    public group: any = null;

    public questions: any[] = [];
    public filteredQuestions: any[] = [];

    public reviewFilter: 'approved' | 'pending' | 'rejected' | null = null;

    public showPdf: boolean = false;
    public pdfSrc: SafeResourceUrl | null = null;

    public isContextMode: boolean = false;
    public contextText: string = '';
    public currentQuestion: any = null;
    public topKDocs: any[] = [];

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( DomSanitizer    )         private sanitizer: DomSanitizer    ) { }

    public showReviewEditModal = false;
    public editingQuestion: any = null;

    public editStatus: 'approved' | 'pending' | 'rejected' | null = null;
    public editComment: string = '';
    public async ngOnInit() {
        if (this.service.init) await this.service.init();
        if (this.service.auth?.allow) await this.service.auth.allow();

        if (!this.id) {
            this.error = '그룹 ID가 존재하지 않습니다.';
            await this.service.render();
            return;
        }

        this.loading = true;
        await this.service.render();

        await this.loadGroupInfo();
        await this.loadReviewData();

        this.loading = false;
        await this.service.render();
    }

    public async loadGroupInfo() {
        try {
            const res = await wiz.call('get_group_detail_review', { id: this.id });

            if (!res || res.code !== 200) {
                this.error = res?.error || '그룹 정보를 불러오지 못했습니다.';
                return;
            }

            this.group = res.data;
        } catch (e) {
            this.error = '그룹 정보를 가져오는 중 오류 발생';
        }

        await this.service.render();
    }

    public async loadReviewData() {
        this.loading = true;
        this.error = null;
        await this.service.render();

        try {
            const res = await wiz.call('get_group_questions_reviewlog', { id: this.id });

            if (!res || res.code !== 200) {
                this.error = res?.error || '검수 내역을 불러올 수 없습니다.';
                this.questions = [];
                this.filteredQuestions = [];
                return;
            }

            const list = Array.isArray(res.data?.data)
                ? res.data.data
                : Array.isArray(res.data)
                    ? res.data
                    : [];

            this.questions = list.map((q: any) => ({
                id: q.id,
                question: q.question,
                answer: q.answer,
                source_file: q.source_file,
                source_page: q.source_page,
                storage_id: q.storage_id,

                status: q.review?.status ?? 'pending',
                comment: q.review?.comment ?? null,
                updated_at: q.review?.updated_at ?? null,
            }));

            this.applyFilter();

        } catch (e) {
            this.error = 'Q&A 데이터를 불러오는 중 오류 발생';
            this.questions = [];
            this.filteredQuestions = [];
        }

        this.loading = false;
        await this.service.render();
    }

    public applyFilter() {
        if (!this.reviewFilter) {
            this.filteredQuestions = this.questions;
        } else {
            this.filteredQuestions = this.questions.filter(
                q => q.status === this.reviewFilter
            );
        }
    }

    public setReviewFilter(status: 'approved' | 'pending' | 'rejected') {
        this.reviewFilter = this.reviewFilter === status ? null : status;
        this.applyFilter();
        this.service.render();
    }

    public async showPdfModal(q: any) {
        this.currentQuestion = q;
        this.isContextMode = false;
        this.contextText = "";

        try {
            const res = await wiz.call("get_topk_for_qa", {
                qa_id: q.id
            });

            if (res && res.code === 200) {
                this.topKDocs = res.data.top_k || [];
            } else {
                this.topKDocs = [];
            }

            for (const doc of this.topKDocs) {
                if (doc.context) {
                    this.isContextMode = true;
                    this.contextText = doc.context;
                    this.showPdf = true;
                    await this.service.render();
                    return;
                }
            }

        } catch (e) {
            this.topKDocs = [];
        }

        const file = q?.source_file;
        const storage = q?.storage_id;

        if (!file || !storage) {
            alert('출처 파일이 없습니다.');
            return;
        }

        const pdfUrl =
            wiz.url('get_pdf_file') +
            `?storage=${encodeURIComponent(storage)}&path=${encodeURIComponent(file)}`;

        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
        this.showPdf = true;

        await this.service.render();
    }

    public onSelectTopK(event: any) {
        const index = Number(event.target.value);
        const doc = this.topKDocs[index];
        if (!doc) return;

        if (doc.context) {
            this.isContextMode = true;
            this.contextText = doc.context;
        } else {
            this.isContextMode = false;

            const pdfUrl =
                wiz.url("get_pdf_file") +
                `?storage=${encodeURIComponent(this.group?.vectordb_id)}` +
                `&path=${encodeURIComponent(doc.file)}` +
                `#page=${doc.page}`;

            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
        }

        this.service.render();
    }

    public async closePdfModal() {
        this.showPdf = false;
        this.pdfSrc = null;
        await this.service.render();
    }

    public goBack() {
        this.router.navigateByUrl('/ui/qadataset');
    }

    public async reload() {
        this.loading = true;
        await this.service.render();

        await this.loadGroupInfo();
        await this.loadReviewData();

        this.loading = false;
        await this.service.render();
    }

    private isDragging = false;
    private dragStartX = 0;
    private dragStartY = 0;

    public startDrag(event: MouseEvent, modalEl: HTMLElement) {
        if (!modalEl) return;
        event.preventDefault();

        this.isDragging = true;
        const rect = modalEl.getBoundingClientRect();

        this.dragStartX = event.clientX - rect.left;
        this.dragStartY = event.clientY - rect.top;

        const onMove = (e: MouseEvent) => {
            if (!this.isDragging) return;
            modalEl.style.left = e.clientX - this.dragStartX + 'px';
            modalEl.style.top = e.clientY - this.dragStartY + 'px';
            modalEl.style.transform = 'none';
            modalEl.style.position = 'fixed';
        };

        const onUp = () => {
            this.isDragging = false;
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    }

    public async submitReviewEdit() {
        if (!this.editingQuestion || !this.editStatus) {
            alert('검수 상태를 선택해 주세요.');
            return;
        }

        try {
            const res = await wiz.call('update_qa_review', {
                qa_id: this.editingQuestion.id,
                status: this.editStatus,
                comment: this.editComment
            });

            if (!res || res.code !== 200) {
                alert(res?.error || '저장에 실패했습니다.');
                return;
            }

            this.editingQuestion.status = this.editStatus;
            this.editingQuestion.comment = this.editComment;

            this.closeReviewEdit();
            this.applyFilter();

        } catch (e) {
            alert('검수 수정 중 오류 발생');
        }

        this.service.render();
    }

    public setEditStatus(status: 'approved' | 'pending' | 'rejected') {
        this.editStatus = status;
        this.service.render();
    }

    public closeReviewEdit() {
        this.showReviewEditModal = false;
        this.editingQuestion = null;
        this.editStatus = null;
        this.editComment = '';
        this.service.render();
    }

    public openReviewEdit(q: any) {
        if (this.isDatasetClosed) {
            alert("마감된 데이터셋은 수정할 수 없습니다.");
            return;
        }

        this.editingQuestion = q;
        this.editStatus = q.status;
        this.editComment = q.comment || '';
        this.showReviewEditModal = true;

        this.service.render();
    }

    get isDatasetClosed(): boolean {
        return this.group?.status_closed === 'Y';
    }

    public async rollBack(q: any) {
        if (this.isDatasetClosed) {
            alert("마감된 데이터셋은 되돌릴 수 없습니다.");
            return;
        }

        if (!confirm('검수를 되돌리시겠습니까?\n되돌린 항목은 검수 목록에서 사라집니다.')) {
            return;
        }

        try {
            const res = await wiz.call('rollback_qa_review', { qa_id: q.id });

            if (!res || res.code !== 200) {
                alert(res?.error || res?.message || '되돌리기에 실패했습니다.');
                return;
            }

            alert('검수가 되돌려졌습니다.');

            this.questions = this.questions.filter(item => item.id !== q.id);
            this.applyFilter();

        } catch (e) {
            alert('되돌리기 중 오류가 발생했습니다.');
        }

        await this.service.render();
    }

    public getStatusCount(status: string): number {
        if (!this.questions) return 0;
        return this.questions.filter(q => q.status === status).length;
    }

    public getTypeLabel(typeValue: string): string {
        const typeMap = {
            'summary': '요약/정리',
            'concept': '개념/이론 설명',
            'reasoning': '기전/병리 인과',
            'decision': '임상 판단/감별/선정',
            'treatment_principle': '치료 원칙/치법',
            'prescription': '처방 운용',
            'procedure': '시술 프로토콜/절차',
            'evidence': '근거 제시',
            'compare': '비교/대조',
            'safety': '주의/금기/부작용'
        };
        return typeMap[typeValue] || typeValue;
    }
}

export default PortalQadatasetReviewlogComponent;